import { Fragment, useEffect, useState, useCallback, useRef, useMemo } from 'react';

import { Link, generatePath, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Strong, Text, Table, Button, Pane, Popover, Position, Paragraph, Menu, EyeOpenIcon, TickIcon, EyeOffIcon } from 'evergreen-ui';

import { compareAsc, isSameDay, parse as parseDateFns, format as formatDateFns, fromUnixTime } from 'date-fns';

import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import _ from 'lodash';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import Zoomable from "react-instagram-zoom";

import { API, I18n } from 'aws-amplify';
import * as queries from '../graphql/queries';

import HeartIcon from '../assets/icons/HeartIcon';
import ShareIcon from '../assets/icons/ShareIcon';

import QRCodeIcon from '../assets/icons/QRCodeIcon';

import PaperPlaneIcon from '../assets/icons/PaperPlaneIcon';
import CommentIcon from '../assets/icons/CommentIcon';
import ProfileIcon from '../assets/icons/ProfileIcon';
import SettingsIcon from '../assets/icons/SettingsIcon';

import FormattedCurrencyNumber, { useFormattedCurrencyNumber } from '../components/FormattedCurrencyNumber';

import TransactionTimestamp from '../components/TransactionTimestamp';
import TransactionFundingStructure from '../components/TransactionFundingStructure';
import TransactionUseStructure from '../components/TransactionUseStructure';

import TransactionHeader from '../components/TransactionHeader';

import AspectRatio from '../components/AspectRatio';

import Footer from '../components/Footer';

import { useSelector, useDispatch, batch } from 'react-redux';
import { setProfileDetails, updateProfileDetails, setTransactionDetails, updateProfileState, setDialogState, updateDialogState, updateTransactionDetails } from '../services/actions';

const TransactionNote = ({ transactionDetails, ...rest }) => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionNote - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionNote - cleaned up");
    }
  }, []);

  let history = useHistory();
  let match = useRouteMatch();
  let location = useLocation();

	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	const profileDetails = useSelector(state => state.profileDetails);
	// const transactionDetails = useSelector(state => state.transactionDetails);
	const localeState = useSelector(state => state.localeState);

  const linesEllipsisRef = useRef(null);

  const [isTextClamped, setIsTextClamped] = useState(true);

  // useEffect(() => {
  //   if (!transactionDetails.note) {
  //     dispatch(updateTransactionDetails({
  //       note: "Test... A visual update from one of our upcycling workshops last week.<br/> <br/>Every week, we work with around 75 adults with learning disabilities in our upcycling workshops (13 per week).  <br/> <br/>With our support and gentle supervision, our trainees are involved in all aspects of the process of restoring old and unwanted furniture: from coming up with a new design for each piece of tired, unloved furniture, through to giving the final coat of wax. Each item of furniture is carefully hand sanded before being passed to our painting team who prime and paint each piece. We are proud of our sustainability and take it to the next level by combining recycling, upcycling, and learning, letting our trainees gain the necessary experience and become experts. <br/> <br/>Our beautiful, finished products are sold and shipped to homes, restaurants, and hospitality settings up and down the country. All profits go towards paid employment opportunities for our trainees. <br/> <br/>Typically, to keep our upcycling 8-person sessions running every week, we require a standard list of supplies:<br/>- 100 specialised joinery masks used when sanding - £100<br/>- paint for around 10 items of furniture - £50<br/>- varnish - £10<br/>- paint brushes, rollers, and sanders - £20<br/>- sandpaper - £25<br/>- handles for furniture - £20<br/>- masking tape - £20<br/> <br/>We are very grateful for all your donations and the difference that you enable us to make for our trainees.<br/> <br/>This week, we would like to express a special thank you to SPS Timber Windows Limited, our generous corporate donor, for their continued support and a proactive effort to raise awareness of our work. <br/> <br/>If you’d like to make a clear impact and help us to do more great work, there are some items that we can never have enough supplies of. If you wish to support us with a donation of any amount, you will see precisely how we spend contributions to create employment opportunities and an environment of inclusion for our wonderful trainees."
  //     }));
  //   }
  // });

  if (!transactionDetails.note) {
    return null;
  }

  return (

    <Pane {...rest} >

      <Pane display="flex" alignItems={"flex-end"} >

        <Strong fontSize={14} color="#283655">{I18n.get('Internal note')}</Strong>
        {/* <Button marginLeft={6} paddingX={6} paddingY={4} height={18} fontSize={12} justifyContent="center" appearance="minimal"
          // disabled={processing}
          onClick={() => {
            setIsFundingHistoryShown(false);
          }}
        >
          {I18n.get('Hide')}
        </Button> */}
      </Pane>
      

      <Pane overflow="scroll" height={"100%"} width={"100%"}
        // maxHeight={250}
      >

        <Pane paddingY={4} paddingRight={4} className="noselect">
          {isTextClamped ?
            <Paragraph fontSize={14} lineHeight={1.3} color="#283655" >
              <Pane
                onClick={(event) => {
                  setIsTextClamped(false);
                }}
              >
                <HTMLEllipsis
                  // https://www.npmjs.com/package/react-lines-ellipsis
                  ref={linesEllipsisRef}

                  // unsafeHTML={`
                  //   <a
                  //     class="inline-link"
                  //     style="fontWeight: 600; color: #283655; "
                  //     href="${generatePath("/:handle", {...match.params, handle: transactionDetails.fromFace?.username})}"
                  //     onclick="event.stopPropagation();"
                  //     target="_self" // target="_blank" // 
                  //     rel="noopener noreferrer"
                  //   >${transactionDetails.fromFace?.name}</a>
                  //   <span>${" "}</span>
                  //   <span class="clickable-text" >${transactionDetails.note}</span>
                  // `}
                  unsafeHTML={`<span class="clickable-text" >${transactionDetails.note}</span>`}

                  maxLine={3} // doesn't strictly work // this should depend on the length of 2nd and 3rd lines
                  ellipsisHTML={`... <span fontSize={15} style="color: #7B8B9A" > ${I18n.get('more')} </span>`}
                  trimRight
                  onReflow={(rleState)=> {
                    // console.log("rleState", rleState);
                    setIsTextClamped(rleState.clamped);
                  }}
                  basedOn='letters'
                  component='div'
                />
              </Pane>
            </Paragraph>
          :
            <Paragraph whiteSpace={"break-spaces"} fontSize={14} lineHeight={1.3} color="#283655" >
              {/* <Text className="inline-link" style={{"fontWeight": "600"}} color="#283655"
                is={Link} to={{
                  pathname: generatePath("/:handle", {...match.params, handle: transactionDetails.fromFace?.username}),
                }}
              >
                {transactionDetails.fromFace.name}
              </Text> */}
              {/* {" "} */}
              {transactionDetails.note.replace(/<br\/>/g,'\r\n')}
            </Paragraph>
          }
          
        </Pane>
        
      </Pane>

      <Pane >
        <Text fontStyle="italic" fontSize={12} color="#7B8B9A" >
          {I18n.get('This note is only visible to you')}
        </Text>
      </Pane>

    </Pane>
  );

}

const TransactionCaption = ({ transactionDetails, ...rest }) => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionCaption - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionCaption - cleaned up");
    }
  }, []);

  let history = useHistory();
  let match = useRouteMatch();
  let location = useLocation();

	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	const profileDetails = useSelector(state => state.profileDetails);
	// const transactionDetails = useSelector(state => state.transactionDetails);
	const localeState = useSelector(state => state.localeState);

  const linesEllipsisRef = useRef(null);

  const [isTextClamped, setIsTextClamped] = useState(true);

  // useEffect(() => {
  //   if (!transactionDetails.caption) {
  //     dispatch(updateTransactionDetails({
  //       caption: "Test ... A visual update from one of our upcycling workshops last week.<br/> <br/>Every week, we work with around 75 adults with learning disabilities in our upcycling workshops (13 per week).  <br/> <br/>With our support and gentle supervision, our trainees are involved in all aspects of the process of restoring old and unwanted furniture: from coming up with a new design for each piece of tired, unloved furniture, through to giving the final coat of wax. Each item of furniture is carefully hand sanded before being passed to our painting team who prime and paint each piece. We are proud of our sustainability and take it to the next level by combining recycling, upcycling, and learning, letting our trainees gain the necessary experience and become experts. <br/> <br/>Our beautiful, finished products are sold and shipped to homes, restaurants, and hospitality settings up and down the country. All profits go towards paid employment opportunities for our trainees. <br/> <br/>Typically, to keep our upcycling 8-person sessions running every week, we require a standard list of supplies:<br/>- 100 specialised joinery masks used when sanding - £100<br/>- paint for around 10 items of furniture - £50<br/>- varnish - £10<br/>- paint brushes, rollers, and sanders - £20<br/>- sandpaper - £25<br/>- handles for furniture - £20<br/>- masking tape - £20<br/> <br/>We are very grateful for all your donations and the difference that you enable us to make for our trainees.<br/> <br/>This week, we would like to express a special thank you to SPS Timber Windows Limited, our generous corporate donor, for their continued support and a proactive effort to raise awareness of our work. <br/> <br/>If you’d like to make a clear impact and help us to do more great work, there are some items that we can never have enough supplies of. If you wish to support us with a donation of any amount, you will see precisely how we spend contributions to create employment opportunities and an environment of inclusion for our wonderful trainees."
  //     }));
  //   }
  // });

  if (!transactionDetails.caption) {
    return null;
  }

  return (

    <Pane {...rest} >

      <Pane overflow="scroll" height={"100%"} width={"100%"}
        // maxHeight={250}
      >

        <Pane paddingY={4} paddingRight={4} className="noselect">
          {isTextClamped ?
            <Paragraph fontSize={14} lineHeight={1.3} color="#283655" >
              <Pane
                onClick={(event) => {
                  setIsTextClamped(false);
                }}
              >
                <HTMLEllipsis
                  // https://www.npmjs.com/package/react-lines-ellipsis
                  ref={linesEllipsisRef}

                  // unsafeHTML={`
                  //   <a
                  //     class="inline-link"
                  //     style="fontWeight: 600; color: #283655; "
                  //     href="${generatePath("/:handle", {...match.params, handle: transactionDetails.fromFace?.username})}"
                  //     onclick="event.stopPropagation();"
                  //     target="_self" // target="_blank" // 
                  //     rel="noopener noreferrer"
                  //   >${transactionDetails.fromFace?.name}</a>
                  //   <span>${" "}</span>
                  //   <span class="clickable-text" >${transactionDetails.caption}</span>
                  // `}
                  unsafeHTML={`<span class="clickable-text" >${transactionDetails.caption}</span>`}

                  maxLine={3} // doesn't strictly work // this should depend on the length of 2nd and 3rd lines
                  ellipsisHTML={`... <span fontSize={15} style="color: #7B8B9A" > ${I18n.get('more')} </span>`}
                  trimRight
                  onReflow={(rleState)=> {
                    // console.log("rleState", rleState);
                    setIsTextClamped(rleState.clamped);
                  }}
                  basedOn='letters'
                  component='div'
                />
              </Pane>
            </Paragraph>
          :
            <Paragraph whiteSpace={"break-spaces"} fontSize={14} lineHeight={1.3} color="#283655" >
              {/* <Text className="inline-link" style={{"fontWeight": "600"}} color="#283655"
                is={Link} to={{
                  pathname: generatePath("/:handle", {...match.params, handle: transactionDetails.fromFace?.username}),
                }}
              >
                {transactionDetails.fromFace.name}
              </Text> */}
              {/* {" "} */}
              {transactionDetails.caption.replace(/<br\/>/g,'\r\n')}
            </Paragraph>
          }
          
        </Pane>



      </Pane>

    </Pane>

  );

}

const TransactionComments = () => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionComments - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionComments - cleaned up");
    }
  }, []);

  let history = useHistory();
  let match = useRouteMatch();
  let location = useLocation();

	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	const profileDetails = useSelector(state => state.profileDetails);
	const transactionDetails = useSelector(state => state.transactionDetails);
	const localeState = useSelector(state => state.localeState);

  const linesEllipsisRef = useRef(null);

  const [isTextClamped, setIsTextClamped] = useState(true);

  if (!transactionDetails.publicTransactionId) {
    return null;
  }

  return (

    <Fragment>

      <Pane borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20" />

      <Pane height={"100%"} width={"100%"}
        marginLeft="auto" marginRight="auto"
      >
        

        <Pane background="green" >
          Comments list
        </Pane>

        {/* <Pane width={"100%"} marginLeft="auto" marginRight="auto" >
          <Pane height={60} width={"100%"} background="blue" >
            "Add new comment box"
          </Pane>
        </Pane> */}



      </Pane>

    </Fragment>

  );

}

const TransactionFooter = () => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionFooter - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionFooter - cleaned up");
    }
  }, []);

  // let history = useHistory();
  // let match = useRouteMatch();
  // let location = useLocation();

	const dispatch = useDispatch();

	// const userState = useSelector(state => state.userState);
	// const profileDetails = useSelector(state => state.profileDetails);
	// const transactionDetails = useSelector(state => state.transactionDetails);
	// const localeState = useSelector(state => state.localeState);


  const [userHasReacted, setUserHasReacted] = useState(false);
  const [countReactions, setCountReactions] = useState(0);

  const countComments = 0 || 0;
  const countShares = 0 || 0;
  const countViews = 0 || 0;

  const handleReaction = () => {
    setCountReactions((c) => {
      if (userHasReacted) {
        setUserHasReacted(false);
        return c - 1;
      }
      else {
        setUserHasReacted(true);
        return c + 1;
      }
    });
  }
  

  return (

    <Fragment>

      <Pane borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20" />
    
      {/* <Pane paddingX={5} paddingY={5} width="100%" alignItems="center" display="flex" flexWrap="wrap" >

        <Button padding={8} width={40} height={40} appearance="minimal" justifyContent="center" >
          <HeartIcon color="#283655" width={24} height={"auto"} />
        </Button>
        <Button padding={8} width={40} height={40} appearance="minimal" justifyContent="center" >
          <CommentIcon color="#283655" width={24} height={"auto"} />
        </Button>
        <Button padding={8} width={40} height={40} appearance="minimal" justifyContent="center"
        onClick={() => {
          
        }}>
          <PaperPlaneIcon color="#283655" width={24} height={"auto"} />
        </Button>

      </Pane> */}

      {/* <Pane paddingY={5} height={30} width={"100%"} >
        <Text fontSize={14} color="#283655" >
          {"Liked by"}{" "}
        </Text>

        <Strong fontSize={14} color="#283655" >
          {"X"}
        </Strong>

        <Text fontSize={14} color="#283655" >
          {" "}{"and"}{" "}
        </Text>

        <Strong fontSize={14} color="#283655" >
          {"13 others"}
        </Strong>
      </Pane> */}

      {/* <Pane paddingY={5} height={30} width={"100%"} >
        <Strong fontSize={14} color="#283655" >
          {"17 likes"}
        </Strong>
      </Pane> */}

      {/* <Pane paddingY={5} height={30} width={"100%"} >
        <Strong fontSize={14} color="#283655" >
          {"17 views"}
        </Strong>
      </Pane> */}

      <Pane paddingX={5} paddingY={5} gap={5} width="100%" alignItems="center" display="flex" flexWrap="wrap" >

        <Button paddingY={4} paddingX={12} appearance="minimal" justifyContent="center" borderRadius={8}
          onClick={() => {
            handleReaction();
          }}
        >
          <HeartIcon color={userHasReacted ? "#EC4C47" : "#7B8B9A"}  width={24} height={24} filled={userHasReacted} />
          {countReactions ? <Text marginLeft={8} fontSize={14} color="#7B8B9A" >{countReactions}</Text> : null}
        </Button>

        <Button paddingY={4} paddingX={12} appearance="minimal" justifyContent="center" borderRadius={8} >
          <CommentIcon color="#7B8B9A" width={24} height={24} />
          {countComments ? <Text marginLeft={8} fontSize={14} color="#7B8B9A" >{countComments}</Text> : null}
        </Button>

        <Button paddingY={4} paddingX={12} appearance="minimal" justifyContent="center" borderRadius={8}
          onClick={() => {
            dispatch(setDialogState({
              componentName: "ShareOptions",
            }));
          }}
        >
          <ShareIcon color={"#7B8B9A"} width={24} height={24}/>
          {countShares ? <Text marginLeft={8} fontSize={14} color="#7B8B9A" >{countShares}</Text> : null}
        </Button>

        {!countViews ? null :
          <Pane padding={4} width={"fit-content"} height={32} alignItems="center" display="flex" flexWrap="wrap" marginLeft="auto" >
            <EyeOpenIcon iconSize={20} color="#7B8B9A" />
            <Text fontSize={12} color="#7B8B9A" marginLeft={8} >{countViews}</Text>
          </Pane>
        }

      </Pane>

    </Fragment>

  );

}

const ImageGallery = ({ imageUrls = []}) => {

  const handleDragStart = (e) => e.preventDefault();
  
  const slideCount = Array.isArray(imageUrls) ? imageUrls.length : 0;
  let centerDots = slideCount < 6 ? slideCount : 3;
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const centerOffset = useRef(0);
  const slideOffset = useRef(0);
  const slideDirectionRightRef = useRef(true);

  const TOTAL_SPACE = 10;
  const SIZES = [6, 4, 2];

  // background="#E4E7EB"

  const items = imageUrls.map((url) => {
    return (
      <AspectRatio ratio={1/1} >
        <Pane position="absolute" width="100%" height="100%" marginLeft="auto" marginRight="auto" className="noselect" >
            <img src={url} alt="" style={{"width": "100%", "height": "100%", "objectFit": "contain", "borderRadius": "inherit"}} onDragStart={handleDragStart} />
        </Pane>
      </AspectRatio>
    );
    
  });

  const NavDots = () => {

    if (slideCount < 2) {
      return null;
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(min, value), max)
    }

    let currentCenterOffset = activeSlideIndex - slideOffset.current;
    if (currentCenterOffset >= 0 && currentCenterOffset < centerDots) {
      centerOffset.current = currentCenterOffset;
    }
    else {
      slideOffset.current = activeSlideIndex - centerOffset.current;
    }

    return (
      <Fragment>
        <Pane alignItems="center" display="flex" flexWrap="wrap" className="noselect" height={18} marginTop={10} justifyContent="center" >
          {Array.from({ length: slideCount }, (v, k) => k).map((e, i, a) => {
            
            const centerPage = parseInt(centerDots / 2, 10) + slideOffset.current;
            const distance = Math.abs(i - centerPage);
            let scaledDistance = clamp(distance - parseInt(centerDots / 2, 10), 0, 3);
            
            if (slideDirectionRightRef.current && slideOffset.current > 2 && i > activeSlideIndex) {
              scaledDistance = scaledDistance - 1;
            }
            else if (!slideDirectionRightRef.current && slideOffset.current < 3 && i < activeSlideIndex) {
              scaledDistance = scaledDistance - 1;
            }
            const size = SIZES[scaledDistance] || 0;
            const margin = size !== 0 ? (TOTAL_SPACE - size) / 2 : 0;


            return (
              <Pane key={`dot-${i}`} flex={"none"} background={activeSlideIndex === i ? "#4e99e9" : "#E4E7EB"} marginLeft={margin} marginRight={0}
                width={size} height={size} borderRadius={"50%"}
                style={{"transition": "width 300ms ease-in-out, height 300ms ease-in-out, margin 300ms ease-in-out, background 800ms ease-in-out",
                "-webkit-transition": "width 300ms ease-in-out, height 300ms ease-in-out, margin 300ms ease-in-out, background 800ms ease-in-out" }}
              ></Pane>
            );
          })}
        </Pane>
      </Fragment>
    );
  }

  if (!Array.isArray(imageUrls)) {
    return null;
  }

  return (
    <Fragment>
      <Zoomable zIndex={20} maxScale={4} style={{"zIndex": 20}} >
        <div style={{ "user-select": "none", "touch-action": "pan-y", "-webkit-user-drag": "none", "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }} >
          <AliceCarousel
            animationType="fadeout" 
            animationDuration={400}
            disableButtonsControls={true}
            disableDotsControls={true}
            autoPlay={false}
            autoPlayInterval={1800}
            swipeExtraPadding={200}
            infinite={false}
            mouseTracking={slideCount > 1}
            touchTracking={slideCount > 1}
            activeIndex={activeSlideIndex}
            // onInitialized={(e) => {
            //   console.log("onInitialized", e);
            // }}
            onSlideChanged={(e) => {
              // console.log("onSlideChanged", e);
              slideDirectionRightRef.current = activeSlideIndex > e.slide ? false : true;
              setActiveSlideIndex(e.slide);
            }}
            // renderDotsItem={(e) => {
            //   console.log("renderDotsItem", e);
            // }}
            // responsive={}
            items={items}
          />
        </div>
      </Zoomable>
      
      <NavDots />

    </Fragment>
  );
}

const TransactionProvisionPosReceipt = ({ transactionDetails, ...rest }) => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionProvisionPosReceipt - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionProvisionPosReceipt - cleaned up");
    }
  }, []);

  // let history = useHistory();
  // let match = useRouteMatch();
  // let location = useLocation();


	// const dispatch = useDispatch();

	// const userState = useSelector(state => state.userState);
	// const profileDetails = useSelector(state => state.profileDetails);
	// const transactionDetails = useSelector(state => state.transactionDetails);
	// const localeState = useSelector(state => state.localeState);

  const [isShownLocal, setIsShownLocal] = useState(false);

  const provisionReceipt = transactionDetails.history?.find((transaction) => (transaction.type === "provisionReceipt"));
  const imageUrls = provisionReceipt?.proofImagesUrls || null;

  if (!imageUrls) {
    return (null);
  }

  return (
    <Pane {...rest} >

      <Pane display="flex" alignItems={"flex-end"} >
      
        <Strong fontSize={14} color="#283655">{I18n.get('Receipt')}</Strong>
        <Button marginLeft={6} paddingX={6} paddingY={4} height={18} fontSize={12} justifyContent="center" appearance="minimal"
          // disabled={processing}
          onClick={() => {
            setIsShownLocal(!isShownLocal);
          }}
        >
          {isShownLocal ?
            I18n.get('Hide')
          :
            I18n.get('Show')
          }
        </Button>
      </Pane>

      {!isShownLocal ? null :

        <Fragment>
          {imageUrls?.length === 0 ?

            <Pane height={60} display={"flex"} alignItems={"center"} >

              <Pane marginLeft="auto" marginRight="auto" >
                <Pane textAlign="center" >
                  <Text fontSize={14} color="#7B8B9A" >{I18n.get("Receipt insights are unavailable due to privacy rules.")}</Text>
                </Pane>
              </Pane>

            </Pane>
          :
            <Pane paddingTop={4} paddingBottom={4} width={"100%"} marginLeft="auto" marginRight="auto" >
              <ImageGallery imageUrls={imageUrls} />
            </Pane>
          }
        </Fragment>
      }
      
    </Pane>
  );

}

const TransactionImpact = ({ transactionDetails, ...rest }) => {

  const feedbackHistorySearch = useMemo(() => {

    const feedbackHistoryCoverRecord = transactionDetails.history?.find((transaction) => (transaction.type === "feedbackHistory"));
    let fetchedResults = transactionDetails.history?.filter((transaction) => (transaction.type === "feedback"))

    return ({
      ...feedbackHistoryCoverRecord?.relatedRecords,
      results: fetchedResults || [],
    });

  }, [transactionDetails.history]);

  const feedbackRelatedRecords = feedbackHistorySearch?.results || [];

  const feedbackRelatedRecordsStatus = feedbackHistorySearch?.status || null; // ???

  const feedbackByRole = _(feedbackRelatedRecords).groupBy("role").value();
  // console.log("feedbackByRole", feedbackByRole);

  function aggregateImpactByUnit(feedbackTransactions, unit = null) {

    if (!feedbackTransactions) {
      return null;
    }

    const impactBreakdownsForUnit = feedbackTransactions.flatMap((t) => (
      t.impact?.filter((impact) => (impact.unit === unit))
    ));

    // console.log("impactBreakdownsForUnit", impactBreakdownsForUnit);

    let aggregatedImpact = {
      unit: unit,
      quantity: _.sumBy(impactBreakdownsForUnit, (o) => {
        return o?.quantity || 0;
      }),
      quantityDurationDays: _.sumBy(impactBreakdownsForUnit, (o) => {
        return o?.quantityDurationDays || 0;
      }),
      references: _.filter(_.union(_.flattenDeep(_.map(impactBreakdownsForUnit, "references"))), el => {
        if (!_.isNull(el) && !_.isUndefined(el)) {
          return true;
        }
      }),
    };

    // console.log("aggregatedImpact", aggregatedImpact);
    
    return aggregatedImpact;
  }

  function arrayImpactByAction(feedbackTransactions, action = null) {

    if (!feedbackTransactions) {
      return null;
    }

    const impactBreakdowns = feedbackTransactions.flatMap((t) => (
      t.impact?.filter((impact) => (impact.action === action))
    ));

    console.log("impactBreakdowns", impactBreakdowns);

    let groupedImpact = _(impactBreakdowns).groupBy("unit").map((objects, key) =>({
      unit: key,
      quantity: _.sumBy(objects, (o) => {
        return o?.quantity || 0;
      }),
      quantityDurationDays: _.sumBy(objects, (o) => {
        return o?.quantityDurationDays || 0;
      }),
      references: _.filter(_.union(_.flattenDeep(_.map(objects, "references"))), el => {
        if (!_.isNull(el) && !_.isUndefined(el)) {
          return true;
        }
      }),
    })).value();

    console.log("groupedImpact", groupedImpact);

    return groupedImpact;
  }

  // let aggregatedImpactBreakdownsByType = _(allImpactBreakdowns)
  //   .groupBy("type")
  //   .map((objects, key) => ({
  //     type: key,
  //     effect: _(objects)
  //       .groupBy("effect")
  //       .map((objects, key) => ({
  //         effect: key,
  //         unit: _(objects)
  //           .groupBy("unit")
  //           .map((objects, key) => ({
  //             unit: key,
  //             quantity: _.sumBy(objects, (o) => {
  //               return o?.quantity || 0;
  //             }),
  //             durationDays: _.sumBy(objects, (o) => {
  //               return o?.durationDays || 0;
  //             }),
  //             quantityDurationDays: _.sumBy(objects, (o) => {
  //               return o?.quantityDurationDays;
  //               // if (o?.durationDays) {
  //               //   return o?.quantity || 0 * o?.durationDays || 0;
  //               // } else {
  //               //   return null;
  //               // }
  //             }),
              // references: _.filter(_.union(_.flattenDeep(_.map(objects, "references"))), el => {
              //   if (!_.isNull(el) && !_.isUndefined(el)) {
              //     return true;
              //   }
              // }),
  //           }))
  //           .value(),
  //       }))
  //       .value(),
  //   }))
  //   .value();

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function dynamicSort(property, order) {
    let sort_order = 1;
    if (order === "desc") {
      sort_order = -1;
    }
    return function (a, b) {
      // a should come before b in the sorted order
      if (a[property] < b[property]) {
        return -1 * sort_order;
        // a should come after b in the sorted order
      }
      else if (a[property] > b[property]) {
        return 1 * sort_order;
        // a and b are the same
      }
      else {
        return 0 * sort_order;
      }
    };
  }

  const mergedAdultDays = aggregateImpactByUnit(feedbackByRole["merged"], "adult")?.quantityDurationDays || 0;
  const mergedChildDays = aggregateImpactByUnit(feedbackByRole["merged"], "child")?.quantityDurationDays || 0;
  const mergedAnimalDays = aggregateImpactByUnit(feedbackByRole["merged"], "animal")?.quantityDurationDays || 0;

  const sumMergedDays = mergedAdultDays + mergedChildDays + mergedAnimalDays;

  const mergedProvideArrayLength = arrayImpactByAction(feedbackByRole["merged"], "provide")?.length || 0;
  const mergedSaveArrayLength = arrayImpactByAction(feedbackByRole["merged"], "save")?.length || 0;
  const mergedContributeArrayLength = arrayImpactByAction(feedbackByRole["merged"], "contribute")?.length || 0;

  const sumArrayLength = mergedProvideArrayLength + mergedSaveArrayLength + mergedContributeArrayLength;


  const ImpactLivesTile = ({key, value, unit}) => {

    if (!value) {
      return null;
    }

    return (
      <Pane
        key={key}
        // display={"flex"}
        textAlign="center"
        flex={"1 0 25%"}
        // width={32}
        minWidth={70}
        paddingX={8}
        justifyContent="center"
      >
  
        <Pane flex="none" >
          <Strong display="contents" flex="none" fontSize={20} color="#283655">{value}</Strong>
        </Pane>
        <Pane paddingTop={2} >
          <Text fontSize={14} color="#7B8B9A" >{I18n.get(unit)}</Text>
        </Pane>
  
      </Pane>
    );
  }


  // when should null be returned ??? 

  if (sumMergedDays + sumArrayLength === 0) {
    
    return (
      <Pane {...rest}>
      
        <Pane height={"100%"} width={"100%"} marginLeft="auto" marginRight="auto" >
          <Pane height={100} display={"flex"} alignItems={"center"} >
            <Pane marginLeft="auto" marginRight="auto" >
              <Pane textAlign="center" className="noselect" >
              
                {transactionDetails.type === "donation" ? 
                  <Strong fontSize={14} color="#7B8B9A">{I18n.get("How the funds are used and the impact they make will be detailed here.")}</Strong>
                : null }

                {transactionDetails.type === "provision" || transactionDetails.type === "provisionByProvider" ? 
                  <Strong fontSize={14} color="#7B8B9A">{I18n.get("How the funds are used and the impact they make will be detailed here.")}</Strong>
                : null }
                
              </Pane>
              <Pane paddingX={10} textAlign="center" >
                <Text fontSize={12} fontStyle="italic" color="#7B8B9A" >{I18n.get("Please return later.")}</Text>
              </Pane>
            </Pane>
          </Pane>
        </Pane>

      </Pane>
    );
  }


  return (
    <Pane {...rest} >

      <Pane display="flex" alignItems={"flex-end"} >
        <Strong fontSize={14} color="#283655">{I18n.get('Impact')}</Strong>
      </Pane>

      {sumMergedDays > 0 ?
        <Fragment>
          <Pane paddingTop={4} display={"flex"} flexWrap={"wrap"} gap={10} >
            <ImpactLivesTile value={mergedAdultDays} unit={I18n.get("adult days")} />
            <ImpactLivesTile value={mergedChildDays} unit={I18n.get("child days")} />
            <ImpactLivesTile value={mergedAnimalDays} unit={I18n.get("animal days")} />
          </Pane>
        </Fragment>
      : null}

      {sumArrayLength > 0 ?
        <Fragment>
          {mergedProvideArrayLength > 0 ?
            <Fragment>

              <Pane paddingTop={4} >
                <Text fontSize={12} color="#7B8B9A" >{I18n.get("By providing")}</Text>
              </Pane>

              <Table is={"table"} width={"100%"} 
                style={{
                  "border-collapse": "collapse"
                }}
              >

                <Table.Body is={"tbody"} id="scrollableDiv" overflow={"scroll"} display={"block"} >
                  {arrayImpactByAction(feedbackByRole["merged"], "provide")?.sort(dynamicSort("quantity", "desc"))?.map((impact) => (
                    <Table.Row is={"tr"} width={"100%"} key={impact?.orderIndex}
                      height={"auto"}
                      minHeight={24}
                      borderStyle={"none"}
                      // isSelectable
                      // onSelect={() => alert(transaction.name)}
                    >

                      <Table.TextCell is={"td"} textAlign="left"
                        paddingLeft={0}
                        paddingRight={5}
                        paddingY={0}
                      >{
                        <Fragment>
                          <Text fontSize={14} color="#283655">{capitalizeFirstLetter(I18n.get(`${impact?.unit}_plural`))}</Text>
                        </Fragment>
                      }</Table.TextCell>

                      <Table.TextCell is={"td"} textAlign="right"
                        paddingX={5}
                        paddingY={0}
                      >{
                        <Fragment>

                          <Strong fontSize={14} color="#283655">{impact?.quantity || 0}</Strong>

                        </Fragment>

                      }</Table.TextCell>

                    </Table.Row>
                  ))}
                </Table.Body>

              </Table>

            </Fragment>
          : null }

          {mergedSaveArrayLength > 0 ?
            <Fragment>
            
              <Pane paddingTop={4} >
                <Text fontSize={12} color="#7B8B9A" >{I18n.get("While saving")}</Text>
              </Pane>

              <Table is={"table"} width={"100%"} 
                style={{
                  "border-collapse": "collapse"
                }}
              >

                <Table.Body is={"tbody"} id="scrollableDiv" overflow={"scroll"} display={"block"} >
                  {arrayImpactByAction(feedbackByRole["merged"], "save")?.map((impact) => (
                    <Table.Row is={"tr"} width={"100%"} key={impact?.orderIndex}
                      height={"auto"}
                      minHeight={24}
                      borderStyle={"none"}
                      // isSelectable
                      // onSelect={() => alert(transaction.name)}
                    >

                      <Table.TextCell is={"td"} textAlign="left"
                        paddingLeft={0}
                        paddingRight={5}
                        paddingY={0}
                      >{
                        <Fragment>
                          <Strong fontSize={14} color="#283655">{capitalizeFirstLetter(I18n.get(`${impact?.unit}_plural`))}</Strong>
                        </Fragment>
                      }</Table.TextCell>

                      <Table.TextCell is={"td"} textAlign="right"
                        paddingX={5}
                        paddingY={0}
                      >{
                        <Fragment>

                          <Strong fontSize={14} color="#283655">{impact?.quantity || 0}</Strong>

                        </Fragment>

                      }</Table.TextCell>

                    </Table.Row>
                  ))}
                </Table.Body>

              </Table>

            </Fragment>
          : null }

          {mergedContributeArrayLength > 0 ?
            <Fragment>

              <Table is={"table"} width={"100%"} 
                style={{
                  "border-collapse": "collapse"
                }}
              >
                <Table.Body is={"tbody"} id="scrollableDiv" overflow={"scroll"} display={"block"} >
                  {arrayImpactByAction(feedbackByRole["merged"], "contribute")?.map((impact) => (
                    <Table.Row is={"tr"} width={"100%"} key={impact?.orderIndex}
                      height={"auto"}
                      minHeight={30}
                      borderStyle={"none"}
                      // isSelectable
                      // onSelect={() => alert(transaction.name)}
                    >

                      <Table.TextCell is={"td"} textAlign="left"
                        paddingLeft={0}
                        paddingRight={5}
                        paddingY={0}
                      >{
                        <Fragment>

                          {impact?.unit !== "unsdgs" ? null :
                            <Fragment>

                              <Pane marginTop={4}>
                                <Text fontSize={12} color="#7B8B9A" >
                                  {I18n.get("Contributing to")}
                                </Text>
                                <Text fontSize={12} color="#7B8B9A" >
                                  {" "}
                                </Text>

                                <Strong fontSize={12} color={"#283655"} className="blue-link"
                                  is={Link}
                                  target="_blank"
                                  to={{
                                    pathname: generatePath("/:page/:goalNumber?", {
                                      page: "goals",
                                      goalNumber: null,
                                    }),
                                    // state: {},
                                  }}
                                >
                                  {I18n.get('UN SDGs')}
                                </Strong>
                                  
                              </Pane>

                              <Pane paddingTop={4} paddingBottom={4} display="flex" flexWrap="wrap" gap={8} >
                                {impact?.references?.map((goalNumber) => (
                                  <Button key={goalNumber} width={24} height={24} padding={0}
                                    // disabled={processing}
                                    justifyContent="center"
                                    className={`un_sdg_${goalNumber}`}
                                    borderRadius={5}
                                    // isActive={breakdown.references?.includes(`${i + 1}`)}
                                    style={{
                                      boxShadow: "none",
                                      // border: "solid",
                                      // borderWidth: "1px",
                                      // borderColor: "#C7CED4",
                                    }}
                                    fontSize={14}
                                    is={Link}
                                    target="_blank"
                                    to={{
                                      pathname: generatePath("/:page/:goalNumber?", {
                                        page: "goals",
                                        goalNumber: goalNumber,
                                      }),
                                      // state: {},
                                    }}
                                  >
                                    {goalNumber}
                                  </Button>
                                ))}
                              </Pane>
                              
                            </Fragment>
                          }

                        </Fragment>
                        
                      }</Table.TextCell>

                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>

            </Fragment>
          : null }


          {!feedbackRelatedRecordsStatus ? null :
            <Fragment
             // "feedbackRelatedRecordsStatus:" ???
             // After completing a post, funding history is still processing…
            >
              "Feedback status:" {feedbackRelatedRecordsStatus}
            </Fragment>
          }


        </Fragment>
      : null }

    </Pane>
  );
  
}

const TransactionFeedback = ({ transactionDetails, ...rest }) => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`TransactionFeedback - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("TransactionFeedback - cleaned up");
    }
  }, []);

  let history = useHistory();
  let match = useRouteMatch();
  let location = useLocation();

	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	// const profileDetails = useSelector(state => state.profileDetails);
	// const transactionDetails = useSelector(state => state.transactionDetails);
	// const localeState = useSelector(state => state.localeState);

  const feedbackHistory = transactionDetails.history?.find((transaction) => (transaction.type === "feedbackHistory"));

  const feedbackRelatedRecords = feedbackHistory?.relatedRecords?.results || [];

  console.log("feedbackRelatedRecords", feedbackRelatedRecords);

  const imageUrls = feedbackRelatedRecords?.flatMap((transaction) => (transaction.proofImagesUrls || [])) || [];

  console.log("imageUrls", imageUrls);

  const isFeedbackExpected = false;

  if (imageUrls?.length === 0 && !isFeedbackExpected) {
    return null;
  }

  if (!feedbackHistory) {

    return (
      <Pane height={"100%"} width={"100%"} marginLeft="auto" marginRight="auto" >
        
        <Pane height={100} display={"flex"} alignItems={"center"} >

          <Pane marginLeft="auto" marginRight="auto" >
            <Pane textAlign="center" className="noselect" >
              <Strong fontSize={14} color="#7B8B9A">{I18n.get("Feedback will be shown here...")}</Strong>
            </Pane>
            <Pane paddingX={10} lineHeight={1.1} textAlign="center" >
              <Text fontSize={14} fontStyle="italic" color="#7B8B9A" >{I18n.get("Please come back later.")}</Text>
            </Pane>
          </Pane>

        </Pane>

      </Pane>
    );
  }

  return (

    <Pane {...rest} >

      {/* <Pane paddingTop={4} paddingBottom={4} width={"100%"} display="flex" alignItems={"flex-end"} >
        <Strong fontSize={14} color="#283655">{I18n.get('Feedback')}</Strong>
      </Pane> */}

      {/* <Pane width={"100%"} marginLeft="auto" marginRight="auto" >
        <AspectRatio ratio={1/1} >
          <Pane height={"100%"} width={"100%"} background="#F9F9FB" >
            "Feedback box"
          </Pane>
        </AspectRatio>
      </Pane> */}

      <Fragment>
        {imageUrls?.length === 0 ?

          <Pane height={60} display={"flex"} alignItems={"center"} >

            <Pane marginLeft="auto" marginRight="auto" >
              <Pane textAlign="center" >
                <Text fontSize={14} color="#7B8B9A" >{I18n.get("Receipt insights are unavailable due to privacy rules.")}</Text>
              </Pane>
            </Pane>

          </Pane>
        :
          <Pane paddingTop={4} paddingBottom={4} width={"100%"} marginLeft="auto" marginRight="auto" >
            <ImageGallery imageUrls={imageUrls} />
          </Pane>
        }
      </Fragment>

    </Pane>

  );

}

const TransactionSuccessView = () => {

	const countRef = useRef(0);
	const isCurrent = useRef(true);
	useEffect(() => {
		countRef.current = countRef.current + 1;
		console.log(`TransactionSuccessView - ${countRef.current}`);
		return () => {
			console.log("TransactionSuccessView - cleaned up");
			isCurrent.current = false;
		}
	}, []);

	let history = useHistory();
  let match = useRouteMatch();
  let location = useLocation();
	
	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	const profileDetails = useSelector(state => state.profileDetails);
	const transactionDetails = useSelector(state => state.transactionDetails);
	const localeState = useSelector(state => state.localeState);

  const handleFormattedCurrencyNumber = useFormattedCurrencyNumber();

	const handleOpenDialogSignIn = () => {
		dispatch(updateProfileState({
			localStage: "DialogAuth",
			localMode: "log-in",
		}));
	};

	const handleOpenDialogSignUp = () => {
		dispatch(updateProfileState({
			localStage: "DialogAuth",
			localMode: "sign-up",
		}));
	};

	return (
		<Fragment>

			{!transactionDetails.localSuccessView ? null :
				<Fragment>

					<Pane height={120}
						// style={{background: "linear-gradient(0deg, #FFFFFF00 10%, rgba(71,184,129,1) 95%)"}}
						// borderTopLeftRadius={10} borderTopRightRadius={10}
					>
						<Pane textAlign="center" >
							<Pane marginTop={10} background="#91d4b3" padding={10} borderRadius="50%" display="inline-block" >
								<Pane background="#7ecda7" padding={10} borderRadius="50%" display="flex">
									<Pane background="#6cc69a" padding={10} borderRadius="50%" display="flex" >
										<TickIcon size={36} color="#FFFFFF" />
									</Pane>
								</Pane>
							</Pane>
						</Pane>

					</Pane>

					<Pane >
						<Pane textAlign="center" flex={1} width="100%" height="auto" className="noselect" >
							<Strong display="contents" flex="none" fontSize={24} color="#283655">{transactionDetails.localSuccessViewHeader || I18n.get('Thank you!')}</Strong>
						</Pane>

						<Pane marginTop={8} textAlign="center" >
              <Text fontSize={14} color="#283655" >
                {transactionDetails.localSuccessViewBody || I18n.get('All went well.')}
              </Text>
            </Pane>

					</Pane>

					{userState.user ? null :
						transactionDetails.localOfferToAuth ?
							<Fragment>
								<Pane textAlign="center" marginTop={10} >
									<Button fontSize={16} padding={8} height={40} justifyContent="center" width="100%" marginLeft="auto" marginRight="auto" className="noselect"
										// disabled={}
										onClick={handleOpenDialogSignIn}
									>
										{I18n.get('Log in into your account')}
									</Button>
									<Pane marginTop={4} >
										<Text textAlign="center" fontSize={12} lineHeight={1.3} fontStyle="italic" color="#7B8B9A" className="noselect" >
											{I18n.get('Track your donation.')}
										</Text>
									</Pane>
								</Pane>
							</Fragment>
							:
							<Fragment>
								<Pane textAlign="center" marginTop={10} >
									<Button fontSize={16} padding={8} height={40} justifyContent="center" width="100%" marginLeft="auto" marginRight="auto" className="noselect"
										// disabled={}
										onClick={handleOpenDialogSignUp}
									>
										{I18n.get('Create account')}
									</Button>
									<Pane marginTop={4} >
										<Text textAlign="center" fontSize={12} lineHeight={1.3} fontStyle="italic" color="#7B8B9A" className="noselect" >
											{I18n.get('Signing up takes just a few seconds')}
										</Text>
									</Pane>
								</Pane>
							</Fragment>
					}

					{!userState.user || transactionDetails.mode !== "allocation" ? null :
						<Fragment>
							<Pane textAlign="center" marginTop={10} >
								<Button fontSize={16} padding={8} height={40} justifyContent="center" width="100%" marginLeft="auto" marginRight="auto" className="noselect"
									// disabled={}
									onClick={() => {
										dispatch(setTransactionDetails({
											type: "donation",
											mode: "allocation",
										}));
										history.push({
											pathname: generatePath("/:page", {page: "new"}),
										});
									}}
								>
									{I18n.get('New allocation')}
								</Button>
							</Pane>
						</Fragment>
					}

					<Pane marginTop={10} marginBottom={10} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20" />

				</Fragment>
			}
			
		</Fragment>
	);
}

const Transaction = () => {

  const countRef = useRef(0);
  const isCurrent = useRef(true);
  useEffect(() => {
    countRef.current = countRef.current + 1;
    console.log(`Transaction - ${countRef.current}`);
    return () => {
      isCurrent.current = false;
      console.log("Transaction - cleaned up");
    }
  }, []);

  let history = useHistory();
  let match = useRouteMatch();
  // let location = useLocation();

	const dispatch = useDispatch();

	const userState = useSelector(state => state.userState);
	// const profileDetails = useSelector(state => state.profileDetails);
	const transactionDetails = useSelector(state => state.transactionDetails);
	const localeState = useSelector(state => state.localeState);

  const [localLoading, setLocalLoading] = useState(transactionDetails.publicTransactionId ? false : true);

  useEffect(() => {
    
    async function getTransactionDetails() {

      setLocalLoading(true);

      let transactionDetails = null;
      const publicTransactionId = match.params.publicTransactionId;
    
      try {
        const response = await API.graphql({
          query: queries.getTransactionDetails,
          variables: {
            publicTransactionId: publicTransactionId,
            currency: localeState.currency,
            locale: localeState.locale,
          },
          authMode: userState.user ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM",
        });
        transactionDetails = response.data.getTransactionDetails;

        // ??? remove
        if (transactionDetails.type === "demoDonation") {
          let demoToFaceName = "Bob";
          let demoFromFaceName = "Demo Supporter";
          switch (localeState.language) {
            case "it":
              demoToFaceName = "Gino";
              demoFromFaceName = "Demo Supporter";
              break;
        
            default:
              break;
          }
          transactionDetails.toFace.name = demoToFaceName;
          transactionDetails.fromFace.name = demoFromFaceName;
        }

        // ??? remove
        if (transactionDetails.type === "demoProvision") {
          let demoToFaceName = "Bob";
          let demoFromFaceName = "GreenGroceries";
          switch (localeState.language) {
            case "it":
              demoToFaceName = "Gino";
              demoFromFaceName = "Supermercato";
              break;
        
            default:
              break;
          }
          transactionDetails.toFace.name = demoToFaceName;
          transactionDetails.fromFace.name = demoFromFaceName;
        }
        
        dispatch(setTransactionDetails(transactionDetails));
        
        setLocalLoading(false);
      }
      catch (error) {
        console.error("within getTransactionDetails", error);
        if (error.errors?.[0]?.message === "No results") {
          history.replace({
            pathname: "/404",
            // search: "",
            // state: state,
          });
        }
        else {
          dispatch(updateTransactionDetails({
            localError: error,
          }));
        }
        setLocalLoading(false);
      }
    }

    if (!transactionDetails.publicTransactionId && !userState.isLoading) {
      getTransactionDetails();
    }
    
  }, [dispatch, history, localeState.currency, localeState.language, localeState.locale, match.params.publicTransactionId, transactionDetails.publicTransactionId, userState.isLoading, userState.user]);


  // clear transactionDetails on cleaned up // why needed ???
  useEffect(() => {

    return () => {
      console.log("Clean up - clear transactionDetails");
      isCurrent.current = false;

      // dispatch(updateTransactionDetails({
			// 	publicTransactionId: undefined,
			// }));
      
      dispatch(setTransactionDetails()); // ???
    }
  }, [dispatch]);

  return (
    <Fragment >
      
      <Pane clearfix maxWidth={960} min-height="100vh" paddingX={12} alignItems="center" marginLeft="auto" marginRight="auto" paddingBottom={150}>

        {/* return somewhere button ??? */}
        
        {/* <Fragment>
          <Pane >
            type: {transactionDetails?.type}
          </Pane>
          <Pane >
            mode: {transactionDetails?.mode}
          </Pane>
          <Pane >
            user: {userState?.user?.name}
          </Pane>
          <Pane >
            profile: {profileDetails?.name}
          </Pane>
        </Fragment> */}

        <Pane marginTop={36} maxWidth={590} marginLeft="auto" marginRight="auto" >
        
          {localLoading && !transactionDetails.publicTransactionId ?

            "loading ..."

          :
            <Fragment>

              <TransactionSuccessView />

              <TransactionHeader transactionDetails={transactionDetails} />

              {/* <Pane width="100%" height={1} borderTop borderTopWidth={1} borderTopStyle="solid" borderColor="#E6E8F0"></Pane> */}

              <TransactionTimestamp
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />
              
              <TransactionNote
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />

              <Pane paddingTop={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20" >
                <TransactionFundingStructure
                  transactionDetails={transactionDetails}
                />
              </Pane>

              <TransactionCaption
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />
              
              <TransactionFeedback
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />

              <TransactionProvisionPosReceipt
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />

              <TransactionUseStructure
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />

              <TransactionImpact
                transactionDetails={transactionDetails}
                paddingTop={4} paddingBottom={4} borderTopWidth={1} borderTopStyle="solid" borderColor="#435A6F20"
              />

              <TransactionFooter />

              {/* <TransactionComments /> */}

            </Fragment>
          }

        </Pane>

        {/* below is just an example of expanding flex... */}

        {/* <Pane minWidth={250} flex={1} maxWidth={590} marginLeft="auto" marginRight="auto" >

          <Pane display="flex" flexFlow="column" height="100%" >

            <Pane flex="0 1 auto" >
              <TransactionHeader />
            </Pane>

            <Pane flex="1 1 auto" >
              <TransactionFundingStructure />
            </Pane>

            <Pane flex="1 1 auto" >
              <TransactionComments />
            </Pane>

            <Pane flex="0 1 auto" >
              <TransactionFooter />
            </Pane>

          </Pane>
          
        </Pane> */}
        

      </Pane>
      <Footer/>
    </Fragment>
  );
}

export default Transaction;